import type { ReactNode } from 'react'
import { useState } from 'react'

import { BgCard } from './components/App.styled'
import { MembershipAllowed } from './components/MembershipAllowed'
import { RegionNotAllowed } from './components/RegionNotAllowed'
import { ZipCheck } from './components/ZipCheck'
import type { AllowedStateType } from './types'


export const App = () => {
  const [allowedState, setAllowedState] = useState<AllowedStateType>('init')

  const appSections: Record<AllowedStateType, ReactNode> = {
    init: <ZipCheck onAllowedState={setAllowedState} />,
    allowed: <MembershipAllowed />,
    notAllowed: <RegionNotAllowed />
  }

  return <BgCard>{appSections[allowedState]}</BgCard>
}

export default App
